import {Badge} from 'antd'
import classNames from 'classnames'
import React from 'react'
import {BiBook, BiCommentError} from 'react-icons/bi'
import {BsLink, BsTextParagraph} from 'react-icons/bs'
import {IoSettings} from 'react-icons/io5'
import {RiErrorWarningLine, RiFilePaper2Line, RiHashtag, RiLink, RiNewspaperLine,} from 'react-icons/ri'
import {CodiSiderHeading} from 'views/Document/components/Codi/CodiSiderHeading'
import {RequiredSystemAdmin} from 'components/RequiredAdmin'
import {CodiActions} from './codiHelpers'
import CodiContext from './CodiContext'
import CodiCurrentDetail from './CodiCurrentDetail'
import CodiIndexes from './CodiIndexes'
import CodiInfo from './CodiInfo'
import CodiKeywords from './CodiKeywords'
import CodiLinks from './CodiLinks'
import CodiManagement from './CodiManagement'
import CodiNotes from './CodiNotes'
import CodiRelatedArticles from './CodiRelatedArticles'
import CodiRelatedCodi from './CodiRelatedCodi'
import CodiRowManagement from './CodiRowManagement'
import CodiSearch from './CodiSearch'
import {SiGooglebigquery} from "react-icons/si";
import CodiBrosCodi from "./CodiBrosCodi";
import {PiBooks} from "react-icons/pi";
import {VscListTree} from "react-icons/vsc";
import {isSystemAdmin} from "../../../helpers/authUtils";

const BlockWrapper = ({style, className, children}) => (
    <div
        style={style}
        className={classNames('flex flex-col gap-2 p-2', className)}>
        {children}
    </div>
)

const {
    info,
    notes,
    links,
    detail,
    search,
    indexes,
    settings,
    keywords,
    relatedCodi,
    brosCodi,
    row_settings,
    relatedArticles,
} = {
    row_settings: {
        key: 'row_settings',
        Icon: BsTextParagraph,
        label: 'management content',
        title: 'management content',
    },
    settings: {
        key: 'settings',
        Icon: BiBook,
        label: 'management',
        title: 'management',
    },
    indexes: {
        key: 'indexes',
        Icon: VscListTree,
        label: 'table of contents',
        title: 'table of contents',
    },
    search: {
        key: 'search',
        Icon: SiGooglebigquery,
        label: 'searches',
        title: 'searches',
    },
    info: {
        key: 'info',
        Icon: RiErrorWarningLine,
        label: 'information',
        title: 'information',
    },
    keywords: {
        key: 'keywords',
        Icon: RiHashtag,
        label: 'keywords',
        title: 'keywords',
    },
    relatedCodi: {
        key: 'related-codi',
        Icon: RiFilePaper2Line,
        label: 'related codi',
        title: 'related codi',
    },
    brosCodi: {
        key: 'bros-codi',
        Icon: PiBooks,
        label: 'bros codi',
        title: 'bros codi',
    },
    relatedArticles: {
        key: 'related-articles',
        Icon: RiNewspaperLine,
        label: 'related articles',
        title: 'related articles',
    },
    detail: {
        key: 'detail',
        Icon: BsTextParagraph,
        label: 'detail',
        title: 'detail',
    },
    notes: {
        key: 'notes',
        Icon: BiCommentError,
        label: 'notes',
        title: 'notes',
    },
    links: {
        key: 'links',
        Icon: RiLink,
        label: 'links',
        title: 'links',
    },
}

const Block = ({header = null, params, children, ...props}) => {
    const Icon = params?.Icon
    return (
        <BlockWrapper {...props}>
            {header ?? (
                <CodiSiderHeading
                    title={params?.title}
                    icon={
                        Icon ? (
                            <Icon
                                size={17}
                                className="text-primary"
                            />
                        ) : undefined
                    }
                />
            )}
            {children}
        </BlockWrapper>
    )
}

export const CodiSettingsBlock = (props) => (
    <RequiredSystemAdmin type={"codi_document"}>
        <Block
            {...props}
            params={settings}>
            <CodiManagement/>
        </Block>
    </RequiredSystemAdmin>
)

export const CodiRowSettingsBlock = (props) => (
    <RequiredSystemAdmin type={"codi_document"}>
        <Block
            {...props}
            params={settings}>
            <CodiRowManagement/>
        </Block>
    </RequiredSystemAdmin>
)

export const CodiIndexesBlock = (props) => (
    <Block
        {...props}
        params={indexes}>
        <CodiIndexes/>
    </Block>
)

export const CodiInfoBlock = (props) => (
    <Block
        {...props}
        params={info}>
        <CodiInfo/>
    </Block>
)

export const CodiDetailBlock = (props) => (
    <Block
        {...props}
        params={detail}>
        <CodiCurrentDetail/>
    </Block>
)

export const CodiNotesBlock = ({current_row, handleAction, ...props}) => (
    <Block
        {...props}
        params={notes}>
        <CodiNotes row={current_row}/>
        <div className="h-12"/>
    </Block>
)

export const CodiLinksBlock = ({current_row, filterActions, ...props}) => (
    <Block
        {...props}
        params={links}>
        <CodiLinks
            row={current_row}
            filterActions={filterActions}
        />
        <div className="h-12"/>
    </Block>
)

export const CodiKeywordsBlock = ({current_row, ...props}) => (
    <Block
        {...props}
        params={keywords}>
        <CodiKeywords row={current_row}/>
    </Block>
)

export const CodiSearchBlock = (props) => (
    <Block
        {...props}
        params={search}>
        <CodiSearch/>
    </Block>
)

export const CodiRelatedCodiBlock = (props) => (
    <Block
        {...props}
        params={relatedCodi}>
        <CodiRelatedCodi/>
    </Block>
)

export const CodiBrosCodiBlock = (props) => (
    <Block
        {...props}
        params={brosCodi}>
        <CodiBrosCodi/>
    </Block>
)

export const CodiRelatedArticlesBlock = (props) => (
    <Block
        {...props}
        params={relatedArticles}>
        <CodiRelatedArticles/>
    </Block>
)
export const codiSiderMenu = {
    divider: {
        type: 'divider',
    },
    info: {
        key: info.key,
        label: info.label,
        icon: <info.Icon size={23}/>,
        modal_action: CodiActions.SHOW_INFO_MODAL,
        Component: CodiInfoBlock,
    },
    indexes: {
        key: indexes.key,
        label: indexes.label,
        icon: <indexes.Icon size={23}/>,
        modal_action: CodiActions.SHOW_INDEXES_MODAL,
        Component: CodiIndexesBlock,
    },
    search: {
        key: search.key,
        label: search.label,
        icon: <search.Icon size={19}/>,
        modal_action: CodiActions.SHOW_SEARCH_MODAL,
        Component: CodiSearchBlock,
    },
    keywords: {
        key: keywords.key,
        label: keywords.label,
        icon: <keywords.Icon size={21}/>,
        modal_action: CodiActions.SHOW_KEYWORDS_MODAL,
        Component: (props) => (
            <CodiContext.Consumer>
                {({current_row}) => (
                    <CodiKeywordsBlock
                        {...props}
                        current_row={current_row}
                    />
                )}
            </CodiContext.Consumer>
        ),
    },
    relatedCodi: {
        key: relatedCodi.key,
        label: relatedCodi.label,
        icon: (
            <Badge count={<BsLink/>}>
                <relatedCodi.Icon size={21}/>
            </Badge>
        ),
        modal_action: CodiActions.SHOW_RELATED_CODI_MODAL,
        Component: CodiRelatedCodiBlock,
    },
    brosCodi: {
        key: brosCodi.key,
        label: brosCodi.label,
        icon: (
            <Badge count={<BsLink/>}>
                <brosCodi.Icon size={21}/>
            </Badge>
        ),
        modal_action: CodiActions.SHOW_BROS_CODI_MODAL,
        Component: CodiBrosCodiBlock,
    },
    relatedArticles: {
        key: relatedArticles.key,
        label: relatedArticles.label,
        icon: (
            <Badge count={<BsLink/>}>
                <relatedArticles.Icon size={21}/>
            </Badge>
        ),
        modal_action: CodiActions.SHOW_RELATED_ARTICLES_MODAL,
        Component: CodiRelatedArticlesBlock,
    },
    settings: {
        key: settings.key,
        label: settings.label,
        icon: (
            <Badge count={<settings.Icon/>}>
                <IoSettings size={21}/>
            </Badge>
        ),
        isInvisible: ({login}) => !isSystemAdmin(login),
        modal_action: CodiActions.SHOW_ADMIN_MODAL,
        Component: CodiSettingsBlock,
    },
    row_settings: {
        key: row_settings.key,
        label: row_settings.label,
        icon: (
            <Badge count={<row_settings.Icon/>}>
                <IoSettings size={21}/>
            </Badge>
        ),
        isInvisible: ({login}) => !isSystemAdmin(login),
        modal_action: CodiActions.SHOW_ADMIN_MODAL,
        Component: CodiRowSettingsBlock,
    },
    detail: {
        key: detail.key,
        label: detail.label,
        icon: <detail.Icon size={21}/>,
        modal_action: CodiActions.SHOW_DETAIL_MODAL,
        Component: CodiDetailBlock,
    },
    notes: {
        key: notes.key,
        label: notes.label,
        icon: <notes.Icon size={21}/>,
        modal_action: CodiActions.SHOW_NOTES_MODAL,
        Component: (props) => (
            <CodiContext.Consumer>
                {({current_row, handleAction}) => (
                    <CodiNotesBlock
                        {...props}
                        current_row={current_row}
                        handleAction={handleAction}
                    />
                )}
            </CodiContext.Consumer>
        ),
    },
    links: {
        key: links.key,
        label: links.label,
        icon: <links.Icon size={21}/>,
        modal_action: CodiActions.SHOW_LINKS_MODAL,
        Component: (props) => (
            <CodiContext.Consumer>
                {({current_row, filterActions}) => (
                    <CodiLinksBlock
                        {...props}
                        current_row={current_row}
                        filterActions={filterActions}
                    />
                )}
            </CodiContext.Consumer>
        ),
    },
}
